module.exports = __webpack_public_path__ + "static/media/parlanguage.38d44786.png";